import React from 'react'
import { useMsal, useAccount } from '@azure/msal-react'
import { authTokenRequest } from '../Config'
import { useDispatch } from 'react-redux'
import { setSaml, setCredentials, setUser } from '../Redux/Auth'
import { initCompleted } from '../../Core/Redux/Startup'
// import config from '../../Core/Config'
import api from '../../Core/Services/Api'
import { fetchUser, logout } from '../Services'
import logger from '../../Common/Utils/Logger'

// at first load, the account prop is null -> an init completed would be dispatched
// but if then the account is evaluated, it is a problem, the init completed
// shouldn't have been dispatched in that case -> clear timeout
let initCompleteTimeout

const Authentication = () => {
  const dispatch = useDispatch()
  const { instance, accounts } = useMsal()
  const account = useAccount(accounts[0] || {})

  React.useEffect(() => {
    if (account) {
      clearTimeout(initCompleteTimeout)
      logger.debug('Acquiring token silent')
      dispatch(setSaml(account))
      instance
        .acquireTokenSilent({
          ...authTokenRequest,
          account: account,
        })
        .then(async (response) => {
          if (response) {
            logger.debug('Token acquired')
            api.setAuthToken(response.accessToken)
            const user = await fetchUser(response.account.username)
            dispatch(setCredentials({ accessToken: response.accessToken, username: response.account.username }))
            dispatch(setUser(user))
            logger.debug('Init completed, with account and token')
            dispatch(initCompleted())
          } else {
            logger.debug('Init completed, with account but no token')
            dispatch(initCompleted())
          }
        })
        .catch((err) => {
          logger.warning('Acquire token silent error: ', err)
          logger.info('Performing logout')
          logout(dispatch)
          dispatch(initCompleted())
        })
    } else {
      initCompleteTimeout = setTimeout(() => {
        logger.debug('Init completed, no account')
        dispatch(initCompleted())
      }, 2000)
    }
  }, [account, instance])

  return null
}

export default Authentication
